<template>
  <BillingPagination />
</template>

<script>
import BillingPagination from "@/components/BillingPagination.vue";

export default {
  components: {
    BillingPagination,
  },
};
</script>
